
const fileObjectUrl = (fileImage) => {
    try {
        return URL.createObjectURL(fileImage)
    }
    catch (err) {
        // console.log(err, 'errerr')
        return fileImage
    }
}

export default fileObjectUrl;